<div class="col">
    <div class="row justify-content-between g-4 p-4">
        <div class="col p-1">
            <button type="button" class="btn btn-secondary btn-lg rounded-3" [routerLink]="['/../shop']">
                <h3 class="font-size-36">Back</h3>
            </button>
        </div>
        <div class="col-auto">
            <h3 class="font-size-36"></h3>
        </div>
    </div>
    <div class="row row-cols-auto justify-content-between g-4 p-4">
        <div class="col">
            <div class="row">
                <div class="col">
                    <div class="row p-1 justify-content-between align-items-center">
                        <h3 class="font-size-36 col-auto p-0">
                            {{ product.productName }}
                        </h3>
                        <div class="col-auto">
                            <div class="bg-primary p-2 rounded-3 col-auto font-size-16 text-white m-auto">
                                Price: ${{ product.price / 100 }}
                            </div>
                        </div>
                    </div>

                    <div class="row justify-content-between p-1">

                    </div>
          
                    <div class="row p-1">
                        <hr/>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="row">
                        <img class="primary-svg col-auto" src="file-lines-regular-full.svg" width="60" height="40" alt="location"/>
                        <h3 class="font-size-32 col">
                            About This Product
                        </h3>
                    </div>
                    <div class="row">
                        <div class="col">
                            <p class="font-size-16">{{ product.productDescription }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card col-12 col-lg-4 border-0">
            @if (product.imgUrls) {
                <ngb-carousel>
                    @for (imgUrl of product.imgUrls; track imgUrl) {
                    <ng-template ngbSlide>
                        <div class="picsum-img-wrapper">
                        <img src="https://cdn.wyvern-weaponry.com/{{ imgUrl }}" class="d-block w-100 crop card-img-top crop rounded-top-4" alt="...">
                        </div>
                    </ng-template>
                    }
                </ngb-carousel>
            }
            <div class="position-absolute mt-3 bg-primary p-1 rounded-3">
                <div class="row justify-content-center p-1 g-1">
                <div class="font-size-16 text-white col-auto"> Qty: {{ product.quantity }} </div>
                </div>
            </div>
            <div class="card-body">
                <div class="d-grid gap-2">
                    <button class="btn btn-primary btn-lg rounded-3 font-size-20" type="submit" (click)="addToCart()"> Add to cart </button>
                </div>
            </div>
        </div>
    </div>
</div>
